import React from 'react';
import { getLocalizedStrings } from '../../profileSettingsLocalizedStrings';
import classes from './profileName.scss';
import SceTextBox from '../../../Common/TextBox/sceText';
import SceButton from '../../../Common/CommonComponents/sceButton';

class ProfileNameCard extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
            defaultName: { firstName: '', lastName: '' },
            name: { 
                firstName: { value: '', isError: false,isValidated: false, default: '', forceValidate: false, errorMsg: 'Please enter a valid first name.' }, 
                lastName: { value: '', isError: false,isValidated: false, default: '', forceValidate: false, errorMsg: 'Please enter a valid last name.' } }, editBtnClicked: false, showSaveError:false
        };
        this.strings = getLocalizedStrings('GeneralSettings');
      }

    componentWillMount() {
        this.setDefaultNameState();
    }

    setDefaultNameState = () => {
        let ProfileName = !_.isEmpty(this.props.profileName) ? this.props.profileName : '';
        if(!_.isEmpty(ProfileName)){
            let updatedState = { ...this.state };
            updatedState.defaultName.firstName = ProfileName.firstName;
            updatedState.name.firstName.value = ProfileName.firstName; 
            updatedState.defaultName.lastName = ProfileName.lastName;
            updatedState.name.lastName.value = ProfileName.lastName;
            this.setState({ ...updatedState });
        }
    }

    editBtnClickHandler = () => {
        window.aUtils.sendAAEvent("button","nameEdit");
        this.setState({editBtnClicked:true});
    }

    inputDataHandler = (data) => {
        if(!data.isError){
            let iD = data.id;
            let updatedState = { ...this.state };
            updatedState.name[iD].value = data.value;
            updatedState.name[iD].isError = data.isError;
            updatedState.name[iD].isValidated = data.isValidated;
             this.setState({ ...updatedState });
        }else{
            let iD = data.id;
            let updatedState = { ...this.state };
            updatedState.name[iD].value = data.value;
            updatedState.name[iD].isError = data.isError;
            updatedState.name[iD].isValidated = data.isValidated;
            this.setState({ ...updatedState });
        }
    }

    saveBtnHandler = () => {
        window.aUtils.sendAAEvent("button","editNameSave");
        if(!(this.state.name.firstName.isValidated) && !(this.state.name.lastName.isValidated)){
            this.setState({editBtnClicked:false});
        }else if(!(this.state.name.firstName.isError) && !(this.state.name.lastName.isError)){
            let requestParams = {};
            requestParams.email = this.props.email;
            requestParams.firstName = this.state.name.firstName.value.trim();
            requestParams.lastName = this.state.name.lastName.value.trim();
            let reqObj = { reqParams: requestParams };
            app.profileSettingsService.updateProfileV2(reqObj).then((response) => {
                if(response.update === 'success'){
                    let updatedState = { ...this.state };
                    let profileData = app.appService.getUserInfo().profileData;
                    profileData.profile.firstName = updatedState.name.firstName.value.trim();
                    profileData.profile.lastName = updatedState.name.lastName.value.trim();
                    app.appService.setProfileData(profileData);
                    app.pubSubService.publish('changeUserName');
                    updatedState.defaultName.firstName = updatedState.name.firstName.value.trim();
                    updatedState.defaultName.lastName = updatedState.name.lastName.value.trim();
                    updatedState.editBtnClicked = false;
                    updatedState.showSaveError = false;
                    this.setState({ ...updatedState });
                }else{
                  
                    let updatedState = { ...this.state };
                     updatedState.showSaveError = true;
                    this.setState({ ...updatedState });
                }
            },(error) => {
               
                let updatedState = { ...this.state };
                updatedState.showSaveError = true;
                this.setState({ ...updatedState });
            });
        }
    }

    cancelBtnHandler = () => {
        this.setDefaultNameState();
        let updatedState = { ...this.state };
        updatedState.editBtnClicked = false;
        updatedState.showSaveError = false;
        this.setState({ ...updatedState });
    }

    getViewToShow = () => {
        if(this.state.editBtnClicked){
            let warningIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Warning.svg';
            let errorView = this.state.showSaveError ? 
                            <div className={classes.nameErrSec}>
                                <img className={classes.warningIcon} src={warningIcon} alt="warning Icon" />
                                <p className={classes.warningMsg}>{this.strings.saveError}</p>
                            </div> : null;
            return(
                <div>
                    <div className={classes.nameLabel}>{this.strings.editNameLabel}</div>
                    <div className={'row ' + classes.editNamePadding}>
                        <div className='col-md-6'>
                            <div>{this.strings.firstName}</div>
                            <div className={classes.nameTextBox}>
                                <SceTextBox 
                                    defaultValue={this.state.defaultName.firstName}
                                    id='firstName'
                                    type='requestorInfoMoveCenterFirstName'
                                    validator={app.appUtil.validator}
                                    onTextUpdatedHandler={this.inputDataHandler}
                                    isError={this.state.name.firstName.isError}
                                    errorMsg={this.state.name.firstName.errorMsg}
                                 />
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className={classes.lastName}>{this.strings.lastName}</div>
                            <div className={classes.nameTextBox}>
                                <SceTextBox 
                                    defaultValue={this.state.defaultName.lastName}
                                    id='lastName'
                                    type='requestorInfoMoveCenterLastName'
                                    validator={app.appUtil.validator}
                                    onTextUpdatedHandler={this.inputDataHandler}
                                    isError={this.state.name.lastName.isError}
                                    errorMsg={this.state.name.lastName.errorMsg}
                                 />
                            </div>
                        </div>
                    </div>
                    <div className={'row ' + classes.editNamePadding}>
                        <div className='col-md-6'>
                            <div className={classes.nameSaveBtn}>
                                <SceButton
                                    id='Save'
                                    buttonType='default'
                                    value={this.strings.save}
                                    onClick={this.saveBtnHandler}
                                />
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className={classes.nameCancelBtn}>
                                <SceButton
                                    id='Cancel'
                                    buttonType='default'
                                    onClick={this.cancelBtnHandler}
                                    value={this.strings.cancel}
                                />
                            </div>
                        </div>
                    </div>
                    {errorView}
                </div>
            );
        }else{
            let fullName = this.state.defaultName.firstName + ' ' + this.state.defaultName.lastName;
            return(
                <div>
                    <div className={classes.nameLabel}>{this.strings.nameLabel}</div>
                    <div className={classes.editButtonPadding}><button className={classes.editButton} id="name" onClick={this.editBtnClickHandler} >{this.strings.editBtn}</button></div>
                    <div className={classes.nameContent}>{fullName}</div>
                </div>
            );
        }
    }

    render(){
        let view = this.getViewToShow();
        return(
            <div className={classes.Card}>
                {view}
            </div>
        );
    }
}

export default ProfileNameCard;